import React from 'react'
import { useTypewriter, Cursor } from "react-simple-typewriter";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaReact, FaNodeJs, FaBootstrap, FaHtml5, FaCss3, FaInstagram } from "react-icons/fa";
import { SiTailwindcss, SiFigma, SiNextdotjs, SiJavascript, SiChatbot, SiFirebase, SiMongodb, SiFiverr } from "react-icons/si";
import { Link } from 'react-router-dom';

const LeftBanner = () => {
    const [text] = useTypewriter({
      words: ["Professional Coder.", "Full Stack Developer.", "AI & Chatbot Developer."],
      loop: true,
      typeSpeed: 20,
      deleteSpeed: 10,
      delaySpeed: 2000,
    });
  return (
    <div className="w-full lgl:w-1/2 flex flex-col gap-20">
      <div className="flex flex-col gap-5">
        <h4 className=" text-lg font-normal">WELCOME TO MY WORLD</h4>
        <h1 className="text-6xl font-bold text-white">
          Hi, I'm <span className="text-designColor capitalize">Wahaj Khan</span>
        </h1>
        <h2 className="text-4xl font-bold text-white">
          a <span>{text}</span>
          <Cursor
            cursorBlinking="false"
            cursorStyle="|"
            cursorColor="#ff014f"
          />
        </h2>
        <p className="text-base font-bodyFont leading-6 tracking-wide">
        I am skilled in React JS , Node JS , Express JS , MongoDB , Firebase and have a good understanding of design principles and user experience design.
        </p>
      </div>
      <div className="flex flex-col xl:flex-row gap-6 lgl:gap-0 justify-between">
        <div>
          <h2 className="text-base uppercase font-titleFont mb-4">
            Find me in
          </h2>
      <div className="flex flex-col gap-4">
        <div className="flex gap-4">
          <span className="bannerIcon">
            <Link to='https://www.linkedin.com/in/m-wahaj-khan/' target='_blank'><FaLinkedinIn /></Link>
          </span>
          <span className="bannerIcon">
            <Link to='https://www.fiverr.com/wahaj_kh/design-website-responsive-using-html-css-bootstrap-website' target='_blank'><SiFiverr /></Link>
          </span>
          <span className="bannerIcon">
            <Link to='https://twitter.com/khanwahaj510' target='_blank'><FaTwitter /></Link>
          </span>
        </div>
      </div>
        </div>
        <div>
          <h2 className="text-base uppercase font-titleFont mb-4">
            BEST SKILL ON
          </h2>
          <div className="flex gap-4">
            <span className="bannerIcon">
              <FaHtml5 />
            </span>
            <span className="bannerIcon">
              <FaCss3 />
            </span>
            <span className="bannerIcon">
              <SiJavascript />
            </span>
            <span className="bannerIcon">
              <FaBootstrap />
            </span>
          </div>
          <div className="flex gap-4">
            <span className="bannerIcon">
              <SiTailwindcss />
            </span>
            <span className="bannerIcon">
              <FaReact />
            </span>
            <span className="bannerIcon">
              <FaNodeJs />
            </span>
            <span className="bannerIcon">
              <SiMongodb />
            </span>
          </div>
          <div className="flex gap-4">
            <span className="bannerIcon">
              <SiFirebase />
            </span>
            <span className="bannerIcon">
              <SiChatbot />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LeftBanner